
import {
    GET_USER_CONTEST_PROFILE_DATA,
    GET_USER_CONTEST_PROFILE_DATA_SUCCESS,
    CONTEST_POST,
    CONTEST_POST_SUCCESS,
    RESET_CONTEST_PROFILE,
    SEND_CONTEST_LIKE_FEEDBACK,
    SEND_CONTEST_LIKE_FEEDBACK_SUCCESS,
    SET_CONTEST_BOOKMARK,
    SET_CONTEST_BOOKMARK_SUCCESS,
    SHARE_CONTEST_DATA,
    SHARE_CONTEST_DATA_SUCCESS,
    REMOVE_CONTEST_LIKE_FEEDBACK,
    REMOVE_CONTEST_LIKE_SUCCESS,
    SEND_CONTEST_MEDIA_REPORT,
    SEND_CONTEST_MEDIA_REPORT_SUCCESS,
    SEND_CONTEST_LIKE_FEATURED_VIDEO_FEEDBACK_SUCCESS,
    SEND_CONTEST_LIKE_CONTEST_DETAIL_FEEDBACK_SUCCESS,
    SEND_CONTEST_MEDIA_DELETE,
    GET_USER_CONTEST_PROFILE_MEDIA,
    GET_USER_CONTEST_PROFILE_MEDIA_SUCCESS,
    SHOW_CONTEST_PROFILE_VIEW_PROFILE_PIC,
    HIDE_CONTEST_PROFILE_VIEW_PROFILE_PIC,
    SHOW_CONTEST_PROFILE_VIEW_INTRO_VIDEO,
    HIDE_CONTEST_PROFILE_VIEW_INTRO_VIDEO,
    UPDATE_PROFILE_MEDIA,
    UPDATE_PROFILE_MEDIA_SUCCESS,
    SHOW_UPLOAD_MEDIA_LOADER,
    HIDE_UPLOAD_MEDIA_LOADER,
    UPDATE_MEDIA_VIEW_COUNT_CONTESTPROFILE_SUCCESS,
    CONTEST_ERROR
} from '../constants/actionTypes';

export const resetContestProfile = () => ({
    type: RESET_CONTEST_PROFILE
});

export const getUserContestProfileData = payload => ({
    type: GET_USER_CONTEST_PROFILE_DATA,
    payload
});

export const getUserContestProfileDataSuccess = payload => ({
    type: GET_USER_CONTEST_PROFILE_DATA_SUCCESS,
    payload
});

export const getUserContestProfileMedia = payload => ({
    type: GET_USER_CONTEST_PROFILE_MEDIA,
    payload
});

export const getUserContestProfileMediaSuccess = payload => ({
    type: GET_USER_CONTEST_PROFILE_MEDIA_SUCCESS,
    payload
});

export const showUploadMediaLoader = payload => ({
    type: SHOW_UPLOAD_MEDIA_LOADER,
    payload
});

export const hideUploadMediaLoader = payload => ({
    type: HIDE_UPLOAD_MEDIA_LOADER,
    payload
});

export const showContestProfileViewProfilePic = () => ({
    type: SHOW_CONTEST_PROFILE_VIEW_PROFILE_PIC
});

export const hideContestProfileViewProfilePic = () => ({
    type: HIDE_CONTEST_PROFILE_VIEW_PROFILE_PIC
});

export const showContestProfileViewIntroVideo = () => ({
    type: SHOW_CONTEST_PROFILE_VIEW_INTRO_VIDEO
});

export const hideContestProfileViewIntroVideo = () => ({
    type: HIDE_CONTEST_PROFILE_VIEW_INTRO_VIDEO
});

export const updateProfileMedia = payload => ({
    type: UPDATE_PROFILE_MEDIA,
    payload
});

export const updateProfileMediaSuccess = payload => ({
    type: UPDATE_PROFILE_MEDIA_SUCCESS,
    payload
});

export const contestPost = payload => ({
    type: CONTEST_POST,
    payload
});

export const contestPostSuccess = payload => ({
    type: CONTEST_POST_SUCCESS,
    payload
});

export const sendContestLikeFeedBack = (payload) => ({
    type: SEND_CONTEST_LIKE_FEEDBACK,
    payload
});

export const sendContestLikeFeedBackSuccess = (payload) => ({
    type: SEND_CONTEST_LIKE_FEEDBACK_SUCCESS,
    payload
});

export const sendContestFeaturedvideoLikeFeedBackSuccess = (payload) => ({
    type: SEND_CONTEST_LIKE_FEATURED_VIDEO_FEEDBACK_SUCCESS,
    payload
});

export const sendContestContestDetailLikeFeedBackSuccess = (payload) => ({
    type: SEND_CONTEST_LIKE_CONTEST_DETAIL_FEEDBACK_SUCCESS,
    payload
});

export const sendContestMediaReport = (payload) => ({
    type: SEND_CONTEST_MEDIA_REPORT,
    payload
});
export const sendContestMediaDelete = (payload) => ({
    type: SEND_CONTEST_MEDIA_DELETE,
    payload
});

export const sendContestMediaReportSuccess = (payload) => ({
    type: SEND_CONTEST_MEDIA_REPORT_SUCCESS,
    payload
});

export const shareContestData = (payload) => ({
    type: SHARE_CONTEST_DATA,
    payload
});

export const shareContestDataSuccess = (payload) => ({
    type: SHARE_CONTEST_DATA_SUCCESS,
    payload
});

export const setContestBookmark = (payload) => ({
    type: SET_CONTEST_BOOKMARK,
    payload
});

export const setContestBookmarkSuccess = (payload) => ({
    type: SET_CONTEST_BOOKMARK_SUCCESS,
    payload
});

export const removeContestLikeFeedback = (payload) => ({
    type: REMOVE_CONTEST_LIKE_FEEDBACK,
    payload
});

export const removeContestLikeFeedBackSuccess = (payload) => ({
    type: REMOVE_CONTEST_LIKE_SUCCESS,
    payload
});

export const updateMediaViewCountContestProfileSuccess = (payload) => ({
    type: UPDATE_MEDIA_VIEW_COUNT_CONTESTPROFILE_SUCCESS,
    payload
});

export const contestError = () => ({
    type: CONTEST_ERROR
});